module.exports = __webpack_public_path__ + "media/images/USA-bride-image3-f2140060009a462ef61181c65704081a.jpg";